import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loader.loading()) {
      <div class="progress-bar">
        <div class="progress-bar-fill"></div>
      </div>
    }
  `,
  styles: `
    .progress-bar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 3px;
      z-index: 99999;
      overflow: hidden;
      background: transparent;
    }

    .progress-bar-fill {
      height: 100%;
      background: var(--success-color, #35e375);
      box-shadow: 0 0 8px var(--success-color, #35e375);
      animation: progress 1.8s ease-in-out infinite;
    }

    @keyframes progress {
      0%   { width: 0;    transform: translateX(0); }
      50%  { width: 70%;  transform: translateX(0); }
      75%  { width: 70%;  transform: translateX(60%); }
      100% { width: 0;    transform: translateX(100vw); }
    }
  `,
})
export class LoaderComponent {
  protected readonly loader = inject(LoaderService);
}
